<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
         <z-page title=" Terminal : Senarai Terminal">
            <w-flex class="mt3">
                <div class="xs6"> 
                    {{cari.jabatan_id}}
                    <z-lookup label="Jabatan" name="jabatan" :url='service_utiliti+"lookup/jabatan"' :sort="false" :cache="false" v-model="cari.jabatan_id"/>
                </div>
                &nbsp;
                <div class="xs6"> 
                    <z-lookup label="Kaunter" name="kaunter" :url='service_kutipan+"lookup/kaunter"' :sort="false" :cache="false" v-model="cari.kaunter_id"/>
                </div>
                
            </w-flex>
            <w-flex class="mt3">
                <div class="xs6"> 
                    <w-input label="Keterangan" v-model="cari.keterangan"> </w-input>
                </div>
                &nbsp;
                <div class="xs6"> 
                    <w-input label="No. Siri" v-model="cari.no_siri"> </w-input>
                </div>
                
            </w-flex>
          
            
             <div class="mt2 text-right">
                
                <w-button class="ml1" v-on:click="reset()" bg-color="warning">
                   <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                </w-button>
                <w-button class="ml1 " @click="search()">
                    <w-icon>fal fa-search</w-icon>&nbsp;Cari
                </w-button>
             </div>
           
            <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-light1--bg white">
                <template #title>
                  <template v-if="form.id > 0">
                    Kemaskini
                  </template>
                  <template v-else>
                    Tambah
                  </template>
                     Terimaan Terminal
                </template>
                <template #default>
                     <w-form ref="form" v-model="dialog.valid" @validate="submit" @success="success">  
                        <w-flex justify-space-between class="mb4">
                            <div class="xs6">
                                <z-lookup label="Jabatan" name="jabatan" :url='service_utiliti+"lookup/jabatan"' :sort="false" :cache="false" v-model="form.jabatan_id" :validators="[validators.required]"/>
                            </div>
                            &nbsp;
                            <div class="xs6">
                                 <z-lookup label="Kaunter" name="kaunter" :url='service_kutipan+"lookup/kaunter"' :sort="false" :cache="false" v-model="form.kaunter_id" :validators="[validators.required]"/>
                            </div>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <div class="xs6">
                                 <z-input label="Keterangan *" v-model="form.keterangan" name="Keterangan" :validators="[validators.required]" />
                            </div>
                            &nbsp;
                            <div class="xs6">
                                <z-input label="No. Siri *" v-model="form.no_siri" name="no_siri" :validators="[validators.required]" />
                            </div>
                        </w-flex>
                        <w-flex justify-space-between class="mb4">
                            <div class="xs6">
                                 <z-input label="Merchant ID *" v-model="form.merchant_id" name="merchant_id" :validators="[validators.required]" />
                            </div>
                            &nbsp;
                            <div class="xs6">
                                <z-input label="Terminal ID *" v-model="form.new_tid" name="new_tid" :validators="[validators.required]" />
                            </div>
                        </w-flex>
                       
                        <w-flex justify-space-between class="mb4">
                            
                            <div class="xs2">
                                <h5 class="fw-semibold m0">
                                      Status
                                </h5>
                                <div class="fw-normal my1 fs-1"> 
                                    <w-switch class="mr6" v-model="form.status"></w-switch>
                                </div>
                            </div>
                        </w-flex>
                      
                       
                    </w-form>
                </template>
                <template #actions>
                  <div class="spacer" />
                    <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
                    <template v-if="total_debit == total_kredit">
                        <w-button class="ml1" :loading="dialog.loading" :disabled="dialog.valid === false" @click="$refs.form.validate()">{{form.saveButton}}</w-button>
                    </template>
                    <template v-else>
                        <w-button class="ml1" :loading="dialog.loading" :disabled="true" >{{form.saveButton}}</w-button>
                    </template>
                    
                </template>
            </w-dialog>
            <br><br>

            <z-table ref="tbluser" title="Senarai Terminal" :headers="table.headers" :items="table.items" :meta="table.meta" class="">
                <template #button>
                    <w-button dark class="indigo-dark2--bg ml1" @click="add()">
                        <w-icon class="mr1">fal fa-plus</w-icon> Tambah
                    </w-button>
                </template>
                <template #item-cell.status="{ item, label, header, index }">
                   
                    <template v-if="item.status == 1">
                        AKTIF
                    </template>
                    <template v-else>
                        TIDAK AKTIF
                    </template>
                </template>
                <template #header-label="{ header, label, index }">
                    <template v-if="header.key == 'action'">
                        Tindakan
                    </template>
                </template>
                

               

               
               
                <template #item-cell.action="{ item, label, header, index }">
                    <w-flex class="flex justify-center">
                        <!-- <w-icon tile @click="show(item)">fal fa-eye</w-icon> -->
                        &nbsp;&nbsp;
                        <w-icon tile @click="edit(item)">fal fa-pencil</w-icon>
                        &nbsp;&nbsp;
                        <w-icon dark tile @click="destroy(item)">fal fa-trash</w-icon>
                       
                    </w-flex>
                </template>
            </z-table>
           
        </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    items: [Array, Object],
  },
  data() {
    return {
        resourceurl: this.service_kutipan+'terminal',
        reload: true,
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Kutipan', route: '/kutipan' },
            { label: 'Kaunter', route: '/kutipan/kaunter' },
            { label: 'Senarai Terminal', route: '/kutipan/kaunter/terminal' }
          ],
       
        form :{},
      
        tabs: [
            { title: 'Butiran', content: '' },
            // { title: 'Jejak Audit', content: '' },
        ],
        cari : {no_siri: '', keterangan: '', jabatan_id: '', kaunter_id: ''},

       
       
        dialogProfil: {
          valid: false,
          show: false,
          fullscreen: false,
          persistent: true,
          persistentNoAnimation: false,
          loading: false,
          width: 800,
          form: {nama: '', email: ''}
        },
    }
         
  },
  methods: {

    search() {
      var url = window.route('kutipan.terimaan.terminal')+'?no_siri='+this.cari.no_siri+'&keterangan='+this.cari.keterangan+'&jabatan_id='+this.cari.jabatan_id+'&kaunter_id='+this.cari.kaunter_id;
      this.$inertia.visit(url, { preserveScroll : true})
    },

    reset(){
      this.cari =  {no_siri: '', keterangan: '', jabatan_id: '', kaunter_id: ''}
      this.search()
    },

    

    addItem() {
        this.form.trans_type.push( {keterangan : null});
    },

    removeItem(index) {
        this.form.trans_type.splice(index, 1);
    },

    

    add() {
            this.form = {
                id : null,
                jabatan_id : null,
                kaunter_id : null,
                keterangan : null,
                status : null,
                no_siri : null,
                merchant_id : null,
                new_tid : null,
                
            }
            this.dialog.show = true
            this.form.saveButton = "Simpan"
    },

    edit(idx) {
        this.form = idx
        this.form.saveButton = "Kemaskini"
        this.dialog.show = true
    },

    // show(idx) {
    //     this.form = idx
    //     this.form.saveButton = "Kemaskini"
    //     this.modal.show = true
    // },
    
       
  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 900
  
  },
    
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
